import { Avatar } from "@mui/material";
import { useState } from "react";
import CustomDataGridV2 from "../../../../components/CustomDataGridV2";
import Flex from "../../../../components/Flex";
import Text from "../../../../components/Text";
import { formatDate } from "../../../../utils/date-time-utility";
import {
  DEF_PAGINATION,
  DGT_Pagination,
  DEFAULT_USER_SRC,
  applyDefaultColumnSettings,
} from "../../../../utils/utils";

const PatientIncompleteDocument = () => {
  const dummyData = [
    {
      uuid: "1",
      documentName: "Intake Form",
      documentCategory: "Uploaded Document",
      provider: {
        name: "Albert Flores",
        avatar: "https://i.pravatar.cc/150?img=12",
      },
      receiveDate: "2024-12-03",
      dueDate: "2024-12-03",
    },
    {
      uuid: "2",
      documentName: "Physical Intake Form",
      documentCategory: "Intake",
      provider: {
        name: "Marvin McKinney",
        avatar: "https://i.pravatar.cc/150?img=13",
      },
      receiveDate: "2024-12-03",
      dueDate: "2024-12-03",
    },
    {
      uuid: "3",
      documentName: "Physical Exam Form",
      documentCategory: "Intake",
      provider: {
        name: "Bessie Cooper",
        avatar: "https://i.pravatar.cc/150?img=14",
      },
      receiveDate: "2024-12-03",
      dueDate: "2024-12-03",
    },
    {
      uuid: "4",
      documentName: "Physical Exam Form",
      documentCategory: "Intake",
      provider: {
        name: "Ronald Richards",
        avatar: "https://i.pravatar.cc/150?img=15",
      },
      receiveDate: "2024-12-03",
      dueDate: "2024-12-03",
    },
  ];

  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);

  const columns = applyDefaultColumnSettings<any>([
    {
      field: "documentName",
      headerName: "Document Name",
      flex: 1,
      minWidth: 200,
      renderCell: ({ value }) => (
        <Text
          color="primary"
          sx={{
            textDecoration: "underline",
            cursor: "pointer",
            "&:hover": {
              opacity: 0.8,
            },
          }}
        >
          {value}
        </Text>
      ),
    },
    {
      field: "documentCategory",
      headerName: "Document Category",
      flex: 1,
      minWidth: 180,
    },
    {
      field: "provider",
      headerName: "Provider",
      flex: 1,
      minWidth: 200,
      renderCell: ({ row }) => (
        <Flex gap={1.5} alignItems="center">
          <Avatar
            src={row?.provider?.avatar || DEFAULT_USER_SRC}
            alt={row?.provider?.name}
            sx={{ width: 40, height: 40 }}
          />
          <Text>{row?.provider?.name || "-"}</Text>
        </Flex>
      ),
    },
    {
      field: "receiveDate",
      headerName: "Receive Date",
      flex: 1,
      minWidth: 150,
      renderCell: ({ value }) => (value ? formatDate(value) : "-"),
    },
    {
      field: "dueDate",
      headerName: "Due Date",
      flex: 1,
      minWidth: 150,
      renderCell: ({ value }) => (value ? formatDate(value) : "-"),
    },
  ]);

  return (
    <CustomDataGridV2
      getRowId={(row) => row?.uuid}
      rows={dummyData ?? []}
      rowCount={dummyData?.length ?? 10}
      columns={columns}
      paginationModel={pagination}
      onPaginationModelChange={setPagination}
      // sortModel={gridSorting}
      // onSortModelChange={setGridSorting}
    />
  );
};

export default PatientIncompleteDocument;
